// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-page {
  padding: 20px;
  color: white;
}

/* ---------- STATS ---------- */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 18px;
}

.stat-card {
  background: linear-gradient(180deg, #0f172a, #020617);
  padding: 18px;
  border-radius: 14px;
  display: flex;
  height: 117px;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
}

.stat-card span {
  font-size: 22px;
}

.stat-card.blue { border-left: 4px solid #3b82f6; }
.stat-card.purple { border-left: 4px solid #a855f7; }
.stat-card.orange { border-left: 4px solid #f97316; }

/* ---------- TABS ---------- */
.tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}

.tabs button {
  background: #020617;
  border: 1px solid #1e293b;
  color: #cbd5f5;
  padding: 8px 14px;
  border-radius: 10px;
  cursor: pointer;
}

.tabs button.active {
  background: #0f172a;
  border-color: #facc15;
  color: #facc15;
}

/* ---------- SEARCH ---------- */
.table-toolbar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
}

.search-input {
  width: 320px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #1e293b;
  background: #020617;
  color: white;
}

.register-btn {
  background: #facc15;
  color: #020617;
  padding: 10px 16px;
  border-radius: 12px;
  font-weight: 600;
  height: 37px;
  border: none;
  cursor: pointer;
}

/* ---------- ROLE BADGE ---------- */
.role-badge {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.role-badge.buyer {
  background: #1e3a8a;
  color: #93c5fd;
}

.role-badge.seller {
  background: #4c1d95;
  color: #d8b4fe;
}

/* ---------- ACTION ---------- */
.icon-btn {
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
}

.muted {
  font-size: 12px;
  opacity: 0.7;
}
.modal-overlay{
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.75);
  display:flex;
  justify-content:center;
  align-items:center;
}

.modal-box{
  width:600px;
  background:#0f1b2d;
  padding:25px;
  border-radius:12px;
  color:white;
  max-height:80vh;
  overflow-y:auto;


  scrollbar-width: none;        
  -ms-overflow-style: none;     
}

.modal-box::-webkit-scrollbar{
  display:none;                 /* Chrome, Safari */
}

.modal-box h2{
  text-align:center;
  margin-bottom:20px;
}

/* Table */

.seller-table{
  width:100%;
  border-collapse:collapse;
  margin-bottom:20px;
}

.seller-table td{
  padding:8px 10px;
  border-bottom:1px solid #1f2a40;
}

.seller-table td:first-child{
  font-weight:600;
  color:#9ca3af;
  width:150px;
}

/* documents */

.doc-section{
  display:flex;
  gap:25px;
  margin-top:15px;
}

.doc-section img{
  width:120px;
  border-radius:6px;
  border:1px solid #1f2a40;
}

/* status */

.status-box{
  margin-top:20px;
}

.status-box select{
  width:100%;
  padding:10px;
  border-radius:6px;
  border:none;
  background:#1f2a40;
  color:white;
}

/* buttons */

.btn-box{
  margin-top:20px;
  display:flex;
  gap:12px;
   justify-content: flex-end;
}

.update-btn{
  background:#3b82f6;
  border:none;
  padding:10px 18px;
  color:white;
  border-radius:6px;
  cursor:pointer;
}

.close-btnn{
  background:#e5e7eb;
  border:none;
  padding:10px 18px;
  border-radius:6px;
  cursor:pointer;
}.status{
  padding:4px 10px;
  border-radius:6px;
  font-size:12px;
  font-weight:600;
  text-transform:capitalize;
}

/* Pending */
.status.pending{
  background:#fef3c7;
  color:#92400e;
}

/* Approved */
.status.approved{
  background:#dcfce7;
  color:#166534;
}

/* Rejected */
.status.rejected{
  background:#fee2e2;
  color:#991b1b;
}

.doc-section {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.doc-section div {
  text-align: center;
}

.doc-section img {
  width: 170px;
  height: 170px;
  object-fit: cover; /* image stretch nahi hogi */
  border-radius: 6px;
  border: 1px solid #ddd;
}

/* .modal-box {
  width: 750px;
  background: linear-gradient(180deg, #0f172a, #020617);
  padding: 25px;
  border-radius: 16px;
  color: white;
  max-height: 85vh;
  overflow-y: auto;
} */

/* HEADER */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.modal-header h2 {
  font-size: 20px;
  font-weight: 600;
}

.close-icon {
  cursor: pointer;
  opacity: 0.7;
}

.close-icon:hover {
  opacity: 1;
}

/* SECTION */
.info-section {
  margin-bottom: 20px;
}

.info-section h3 {
  margin-bottom: 12px;
  color: #facc15;
  font-size: 15px;
}

/* GRID */
.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.info-grid div {
  background: #020617;
  border: 1px solid #1e293b;
  padding: 10px 12px;
  border-radius: 10px;
}

.info-grid span {
  font-size: 11px;
  color: #9ca3af;
}

.info-grid p {
  margin-top: 3px;
  font-size: 14px;
  font-weight: 500;
}

/* DOC SECTION */
.doc-section {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}

.doc-item {
  background: #020617;
  padding: 10px;
  border-radius: 10px;
  text-align: center;
  border: 1px solid #1e293b;
}

.doc-item p {
  font-size: 12px;
  margin-bottom: 8px;
  color: #9ca3af;
}

.doc-item img {
  width: 130px;
  height: 130px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
}

/* STATUS */
.status-box {
  margin-top: 20px;
}

.status-box select {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #020617;
  border: 1px solid #1e293b;
  color: white;
}

/* BUTTONS */
.btn-box {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.update-btn {
  background: #facc15;
  color: black;
  border: none;
  padding: 10px 18px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
}

.close-btnn {
  background: #1e293b;
  border: none;
  padding: 10px 18px;
  border-radius: 10px;
  color: white;
  cursor: pointer;
}
/* Spinner Animation */
.loading-spinner::before {
  content: '';
  width: 30px;
  height: 30px;
  margin-right: 12px;
  border: 3px solid #1e293b;
  border-top-color: #facc15;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/AllUsers/UserList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB,8BAA8B,EAAE;AAClD,oBAAoB,8BAA8B,EAAE;AACpD,oBAAoB,8BAA8B,EAAE;;AAEpD,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;;;EAGf,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,YAAY,kBAAkB,mBAAmB;AACnD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,UAAU;;AAEV;EACE,UAAU;EACV,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA,cAAc;;AAEd;EACE,YAAY;EACZ,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,WAAW;;AAEX;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA,YAAY;;AAEZ;EACE,eAAe;EACf,YAAY;EACZ,QAAQ;GACP,yBAAyB;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB,CAAC;EACC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB,EAAE,4BAA4B;EAC/C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;GAQG;;AAEH,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA,sBAAsB;AACtB;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".user-page {\n  padding: 20px;\n  color: white;\n}\n\n/* ---------- STATS ---------- */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 18px;\n}\n\n.stat-card {\n  background: linear-gradient(180deg, #0f172a, #020617);\n  padding: 18px;\n  border-radius: 14px;\n  display: flex;\n  height: 117px;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 600;\n}\n\n.stat-card span {\n  font-size: 22px;\n}\n\n.stat-card.blue { border-left: 4px solid #3b82f6; }\n.stat-card.purple { border-left: 4px solid #a855f7; }\n.stat-card.orange { border-left: 4px solid #f97316; }\n\n/* ---------- TABS ---------- */\n.tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.tabs button {\n  background: #020617;\n  border: 1px solid #1e293b;\n  color: #cbd5f5;\n  padding: 8px 14px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.tabs button.active {\n  background: #0f172a;\n  border-color: #facc15;\n  color: #facc15;\n}\n\n/* ---------- SEARCH ---------- */\n.table-toolbar {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.search-input {\n  width: 320px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  border: 1px solid #1e293b;\n  background: #020617;\n  color: white;\n}\n\n.register-btn {\n  background: #facc15;\n  color: #020617;\n  padding: 10px 16px;\n  border-radius: 12px;\n  font-weight: 600;\n  height: 37px;\n  border: none;\n  cursor: pointer;\n}\n\n/* ---------- ROLE BADGE ---------- */\n.role-badge {\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.role-badge.buyer {\n  background: #1e3a8a;\n  color: #93c5fd;\n}\n\n.role-badge.seller {\n  background: #4c1d95;\n  color: #d8b4fe;\n}\n\n/* ---------- ACTION ---------- */\n.icon-btn {\n  background: transparent;\n  border: none;\n  color: white;\n  cursor: pointer;\n}\n\n.muted {\n  font-size: 12px;\n  opacity: 0.7;\n}\n.modal-overlay{\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.75);\n  display:flex;\n  justify-content:center;\n  align-items:center;\n}\n\n.modal-box{\n  width:600px;\n  background:#0f1b2d;\n  padding:25px;\n  border-radius:12px;\n  color:white;\n  max-height:80vh;\n  overflow-y:auto;\n\n\n  scrollbar-width: none;        \n  -ms-overflow-style: none;     \n}\n\n.modal-box::-webkit-scrollbar{\n  display:none;                 /* Chrome, Safari */\n}\n\n.modal-box h2{\n  text-align:center;\n  margin-bottom:20px;\n}\n\n/* Table */\n\n.seller-table{\n  width:100%;\n  border-collapse:collapse;\n  margin-bottom:20px;\n}\n\n.seller-table td{\n  padding:8px 10px;\n  border-bottom:1px solid #1f2a40;\n}\n\n.seller-table td:first-child{\n  font-weight:600;\n  color:#9ca3af;\n  width:150px;\n}\n\n/* documents */\n\n.doc-section{\n  display:flex;\n  gap:25px;\n  margin-top:15px;\n}\n\n.doc-section img{\n  width:120px;\n  border-radius:6px;\n  border:1px solid #1f2a40;\n}\n\n/* status */\n\n.status-box{\n  margin-top:20px;\n}\n\n.status-box select{\n  width:100%;\n  padding:10px;\n  border-radius:6px;\n  border:none;\n  background:#1f2a40;\n  color:white;\n}\n\n/* buttons */\n\n.btn-box{\n  margin-top:20px;\n  display:flex;\n  gap:12px;\n   justify-content: flex-end;\n}\n\n.update-btn{\n  background:#3b82f6;\n  border:none;\n  padding:10px 18px;\n  color:white;\n  border-radius:6px;\n  cursor:pointer;\n}\n\n.close-btnn{\n  background:#e5e7eb;\n  border:none;\n  padding:10px 18px;\n  border-radius:6px;\n  cursor:pointer;\n}.status{\n  padding:4px 10px;\n  border-radius:6px;\n  font-size:12px;\n  font-weight:600;\n  text-transform:capitalize;\n}\n\n/* Pending */\n.status.pending{\n  background:#fef3c7;\n  color:#92400e;\n}\n\n/* Approved */\n.status.approved{\n  background:#dcfce7;\n  color:#166534;\n}\n\n/* Rejected */\n.status.rejected{\n  background:#fee2e2;\n  color:#991b1b;\n}\n\n.doc-section {\n  display: flex;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.doc-section div {\n  text-align: center;\n}\n\n.doc-section img {\n  width: 170px;\n  height: 170px;\n  object-fit: cover; /* image stretch nahi hogi */\n  border-radius: 6px;\n  border: 1px solid #ddd;\n}\n\n/* .modal-box {\n  width: 750px;\n  background: linear-gradient(180deg, #0f172a, #020617);\n  padding: 25px;\n  border-radius: 16px;\n  color: white;\n  max-height: 85vh;\n  overflow-y: auto;\n} */\n\n/* HEADER */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 18px;\n}\n\n.modal-header h2 {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.close-icon {\n  cursor: pointer;\n  opacity: 0.7;\n}\n\n.close-icon:hover {\n  opacity: 1;\n}\n\n/* SECTION */\n.info-section {\n  margin-bottom: 20px;\n}\n\n.info-section h3 {\n  margin-bottom: 12px;\n  color: #facc15;\n  font-size: 15px;\n}\n\n/* GRID */\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.info-grid div {\n  background: #020617;\n  border: 1px solid #1e293b;\n  padding: 10px 12px;\n  border-radius: 10px;\n}\n\n.info-grid span {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.info-grid p {\n  margin-top: 3px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* DOC SECTION */\n.doc-section {\n  display: flex;\n  gap: 20px;\n  margin-top: 10px;\n}\n\n.doc-item {\n  background: #020617;\n  padding: 10px;\n  border-radius: 10px;\n  text-align: center;\n  border: 1px solid #1e293b;\n}\n\n.doc-item p {\n  font-size: 12px;\n  margin-bottom: 8px;\n  color: #9ca3af;\n}\n\n.doc-item img {\n  width: 130px;\n  height: 130px;\n  object-fit: cover;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n/* STATUS */\n.status-box {\n  margin-top: 20px;\n}\n\n.status-box select {\n  width: 100%;\n  padding: 10px;\n  border-radius: 10px;\n  background: #020617;\n  border: 1px solid #1e293b;\n  color: white;\n}\n\n/* BUTTONS */\n.btn-box {\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.update-btn {\n  background: #facc15;\n  color: black;\n  border: none;\n  padding: 10px 18px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.close-btnn {\n  background: #1e293b;\n  border: none;\n  padding: 10px 18px;\n  border-radius: 10px;\n  color: white;\n  cursor: pointer;\n}\n/* Spinner Animation */\n.loading-spinner::before {\n  content: '';\n  width: 30px;\n  height: 30px;\n  margin-right: 12px;\n  border: 3px solid #1e293b;\n  border-top-color: #facc15;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
